<footer>
    <div class="footer-large">

        <div class="content-wrap">
            <div class="footer-links-col first first-footer-col">
                <span tabindex="0" class="heading"
                    (click)="toggleDisplay('IWantTo')">{{'MAIN_PAGE.I_WANT_TO' | translate}}</span>
                <ul *ngIf="IWantTo" [ngClass]="{
                    'open': IWantTo
                  }">
                    <li><a href="https://www.dfa.ie/passports/"
                            target='_blank'>{{'MAIN_PAGE.GET_PASSPORT' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/travel/visas/"
                            target='_blank'>{{'MAIN_PAGE.GET_VISA' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/travel/our-services/authenticating-documents/"
                            target='_blank'>{{'MAIN_PAGE.AUTH_DOCUMENT' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/travel/our-services/marriage-and-civil-partnership-abroad/"
                            target='_blank'>{{'MAIN_PAGE.MARRIED_ABROAD' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/our-role-policies/international-priorities/international-law/find-a-treaty/"
                            target='_blank'>{{'MAIN_PAGE.FIND_TREATY' | translate}}</a>
                    </li>
                </ul>
            </div>
            <div class="footer-links-col">
                <span tabindex="0" class="heading"
                    (click)="toggleDisplay('PassportAndCitizenship')">{{'MAIN_PAGE.PASS_AND_CITIZEN' | translate}}</span>
                <ul *ngIf="PassportAndCitizenship" [ngClass]="{
                    'open': PassportAndCitizenship
                  }">
                    <li><a href="https://www.dfa.ie/passports/how-to-apply-for-a-passport/"
                            target='_blank'>{{'MAIN_PAGE.HOW_TO_APPLY' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/passports/questions/"
                            target='_blank'>{{'MAIN_PAGE.TOP_PASSPORT_QUESTIONS' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/passporttracking/"
                            target='_blank'>{{'MAIN_PAGE.TRACK_PASSPORT' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/citizenship/"
                            target='_blank'>{{'MAIN_PAGE.CITIZENSHIP' | translate}}</a></li>
                </ul>
            </div>
            
            <div class="footer-links-col">
                <span tabindex="0" class="heading"
                    (click)="toggleDisplay('Travel')">{{'MAIN_PAGE.TRAVEL' | translate}}</span>
                <ul *ngIf="Travel" [ngClass]="{
                    'open': Travel
                  }">
                    <li><a href="https://www.dfa.ie/travel/assistance-abroad/"
                            target='_blank'>{{'MAIN_PAGE.ASSISTANCE_ABOARD' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/travel/travel-advice/"
                            target='_blank'>{{'MAIN_PAGE.TRAVEL_ADVICE' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/travel/visas/" target='_blank'>{{'MAIN_PAGE.VISAS' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/travel/citizens-registration/"
                            target='_blank'>{{'MAIN_PAGE.CITIZEN_REGISTRATION' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/travel/our-services/"
                            target='_blank'>{{'MAIN_PAGE.OUR_SERVICES' | translate}}</a></li>
                </ul>
            </div>
            <div class="footer-links-col">
                <span tabindex="0" class="heading"
                    (click)="toggleDisplay('WhatWeDo')">{{'MAIN_PAGE.WHAT_WE_DO' | translate}}</span>
                <ul *ngIf="WhatWeDo" [ngClass]="{
                    'open': WhatWeDo
                  }">
                    <li><a href="https://www.dfa.ie/our-role-policies/our-work/"
                            target='_blank'>{{'MAIN_PAGE.OUR_WORK' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/embassies/irish-embassies-abroad/"
                            target='_blank'>{{'MAIN_PAGE.EMBASSIES_AZ' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/about-us/what-we-do/"
                            target='_blank'>{{'MAIN_PAGE.WHAT_WE_DO' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/about-us/working-with-us/"
                            target='_blank'>{{'MAIN_PAGE.WORK_WITH_US' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/news-and-media/publications/"
                            target='_blank'>{{'MAIN_PAGE.PUBLICATIONS' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/about-us/accountability/how-we-are-accountable/foi-publication-scheme/"
                            target='_blank'>{{'MAIN_PAGE.FREEDOM_OF_INFORMATION' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/about-us/our-commitments/privacy-policy/"
                            target='_blank'>{{'MAIN_PAGE.DATA_PRIVACY_NOTICE' | translate}}</a>
                    </li>
                </ul>
            </div>
            
            <div class="footer-links-col">
                <span tabindex="0" class="heading"
                    (click)="toggleDisplay('NewsAndMedia')">{{'MAIN_PAGE.NEWS_AND_MEDIA' | translate}}</span>
                <ul *ngIf="NewsAndMedia" [ngClass]="{
                    'open': NewsAndMedia
                  }">
                    <li><a href="https://www.dfa.ie/news-and-media/press-releases/"
                            target='_blank'>{{'MAIN_PAGE.PRESS_RELEASES' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/news-and-media/media-services/social-media-policy/"
                            target='_blank'>{{'MAIN_PAGE.SOCIAL_MEDIA' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/news-and-media/speeches/"
                            target='_blank'>{{'MAIN_PAGE.SPEECHES' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/news-and-media/media-services/"
                            target='_blank'>{{'MAIN_PAGE.MEDIA_SERVICES' | translate}}</a></li>
                    <li><a href="https://twitter.com/dfatirl" target="_blank"><img alt="twitter"
                                src="https://www.dfa.ie/media/dfa/styleassets/images/twitter.gif"
                                style="width: 16px; height: 17px;"
                                title="twitter">&nbsp;{{'MAIN_PAGE.TWITTER_FOLLOW_US' | translate}}</a></li>
                    <li><a href="https://www.facebook.com/dfatireland" target="_blank"><img alt="Facebook Logo 16px"
                                src="https://www.dfa.ie/media/embassydenmark/facebook-logo-16x17px.jpg"
                                style="width: 16px; height: 17px;"
                                title="Facebook Logo 16px">&nbsp;{{'MAIN_PAGE.FACEBOOK_FOLLOW_US' | translate}}</a></li>
                </ul>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
    
    <div class="footer-row landing-feature-section">
        <div class="content-wrap">
            <div class="footer-links">
                <ul class="footer-links-list">
                    <li><a href="https://www.dfa.ie/about-us/contact-us/"
                            target='_blank'>{{'MAIN_PAGE.CONTACT_US' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/sitemap/" target='_blank'>{{'MAIN_PAGE.SITEMAP' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/about-us/" target='_blank'>{{'MAIN_PAGE.ABOUT_US' | translate}}</a>
                    </li>
                    <li><a href="https://www.gov.ie" target="_blank">{{'MAIN_PAGE.GOV_IE_LINK' | translate}}</a></li>
                    <li><a href="https://www.dfa.ie/about-us/our-commitments/privacy-policy/"
                            target='_blank'>{{'MAIN_PAGE.PRIVACY_POLICY' | translate}}</a>
                    </li>
                    <li><a href="https://www.dfa.ie/about-us/our-commitments/cookies-policy/"
                            target='_blank'>{{'MAIN_PAGE.COOKIE_POLICY' | translate}}</a>
                    </li>
                </ul>

            </div>

        </div>
    </div>
    <a (click)="backToTop()" [routerLink]="" attr.aria-label="Back to top" title="Back to top" id="return-to-top" role="button"
        style="display: inline;"><em class="fa fa-chevron-up"></em><span class="sr-only">Back To Top</span></a>
</footer>